import React, { useEffect } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import '../../styles/Notification.css'; // We will create this

const NotificationItem = ({ id, type, message, duration, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose(id);
        }, duration);

        return () => clearTimeout(timer);
    }, [id, duration, onClose]);

    const getIcon = () => {
        switch (type) {
            case 'success': return <FaCheckCircle className="notification-icon success" />;
            case 'error': return <FaExclamationCircle className="notification-icon error" />;
            default: return <FaInfoCircle className="notification-icon info" />;
        }
    };

    return (
        <div className={`notification-item ${type}`}>
            <div className="notification-content">
                {getIcon()}
                <span className="notification-message">{message}</span>
            </div>
            <button className="notification-close" onClick={() => onClose(id)}>
                <FaTimes />
            </button>
        </div>
    );
};

export default NotificationItem;
